import storage from 'proxy-storage';
import defaultStorage from './defaultStorage';
import clone, {merge} from '../../utils/clone';

/**
 * @public
 * Gets the `hc` object stored in the web storage.
 *
 * @return {Object}
 */
export default function getHCStorage() {
  const hcStorage = storage.getItem('hc');
  if (!hcStorage) {
    storage.setItem('hc', defaultStorage);
    return defaultStorage;
  }
  if (hcStorage.version !== defaultStorage.version) {
    const hcUpdated = clone(defaultStorage);
    merge(hcUpdated, hcStorage);
    storage.setItem('hc', hcUpdated);
    return hcUpdated;
  }
  return hcStorage;
}
